<template>
  <div v-if="show" class="cloud-dialog-mask" :class="oneHikIdLoading ? 'cloud-dialog-mask-full' : ''">
    <div class="cloud-dialog" :style="computeStyle">
      <slot></slot>
    </div>
  </div>
</template>

<script>
import getSameLevelMaxZindex from '@pro/common/utils/getSameLevelMaxZindex';
export default {
  name: 'CloudDialog',
  props: {
    title: {
      type: [Number, String],
      default: ''
    },
    value: {
      type: Boolean,
      default: false
    },
    area: {
      type: Array,
      required: true
    },
    appendInBody: {
      type: Boolean,
      default: true
    }
  },
  data() {
    return {
      show: false,
      isAddVisibleClass: false
    };
  },
  computed: {
    oneHikIdLoading() {
      return localStorage.getItem('oneHikId-loading-flag');
    },
    computeClass() {
      return {
        'cloud-dialog-visible': this.isAddVisibleClass
      };
    },
    computeStyle() {
      return {
        width: `${this.area[0] }px`,
        height: `${this.area[1] }px`
      };
    }
  },
  watch: {
    value(newVal) {
      this.show = newVal;
      this.isAddVisibleClass = newVal;
      if (newVal) {
        this.$nextTick(() => {
          this.$el.style.zIndex = getSameLevelMaxZindex(this.$el) + 1 < 2000 ? 2000 : getSameLevelMaxZindex(this.$el);
        });
      }
    },
    show(newVal) {
      this.$emit('input', newVal);
    }
  },
  mounted() {
    this.show = this.value;
    if (this.appendInBody) {
      this.isAddVisibleClass = false;
      this.$nextTick(() => {
        document.querySelector('body').appendChild(this.$el);
        this.isAddVisibleClass = true;
      });
    } else {
      this.isAddVisibleClass = true;
    }
  },
  beforeDestroy() {
    this.show = false;
  },
  destroyed() {
    if (this.appendInBody && this.$el && this.$el.parentNode) {
      this.$el.parentNode.removeChild(this.$el);
    }
  },
  methods: {
    close() {
      this.isAddVisibleClass = false;
      setTimeout(() => {
        this.show = false;
      }, 200);
    }
  }
};
</script>

<style lang="scss" scoped>
.cloud-dialog-mask {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: rgba(77, 77, 77, 0.4);
  transition: ease-in-out 0.2s all;
  overflow-y: auto;
}

.cloud-dialog-mask-full {
  background: #fff;
}
.cloud-dialog {
  position: absolute;
  margin: auto;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: #fff;
  z-index: 1999;
  opacity: 1;
  transition: ease-in-out 0.2s all;
  transform: translateY(-10px);
  background-color: #fff;
}
.cloud-dialog-visible {
  opacity: 1;
  transform: translateY(0);
}
</style>
